import { SentimentEnum, SENTIMENTS } from "schema"

export const getSentimentLabel = (sentiment: number, t: (key: string) => string) => {
  if (sentiment === 4) {
    const result = SENTIMENTS.find((e) => e.value === SentimentEnum.VeryPositive)
    if (result) {
      return t(result.label)
    }
  }

  const result = SENTIMENTS.find((e) => sentiment >= e.range[0] && sentiment < e.range[1])
  if (result) {
    return t(result.label)
  }

  return "-"
}

export const getSentimentColor = (sentiment: number) => {
  if (sentiment === 4) {
    const result = SENTIMENTS.find((e) => e.value === SentimentEnum.VeryPositive)
    if (result) {
      return result.color
    }
  }

  const result = SENTIMENTS.find((e) => sentiment >= e.range[0] && sentiment < e.range[1])

  return result?.color ?? "muted"
}

export const getSolveRateColor = (solveRate: number) => {
  if (solveRate < 0.2) return "support-primary"
  if (solveRate < 0.5) return "support-secondary"
  return "neutral"
}

export const getQuestionSolveRateColor = (solveRate: number) => {
  if (solveRate < 0.5) return "chart-4"
  return "neutral"
}

export const getUrgencyColor = (highUrgencyRate: number, highAndMediumRate?: number | null) => {
  const high = Math.max(0, Math.min(1, highUrgencyRate))
  const nested = Math.max(high, Math.min(1, highAndMediumRate ?? high))
  const medium = nested - high
  const low = 1 - nested

  if (high > 0.3) return "support-primary"
  if (high >= medium && high >= low) return "support-primary"
  if (medium >= low) return "support-secondary"
  return "neutral"
}

export const getFulfillmentColor = (fulfillmentRate: number) => {
  if (fulfillmentRate < 0.2) return "chart-3"
  if (fulfillmentRate < 0.5) return "chart-2"
  return "neutral"
}
